import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container flex flex-col justify-center px-4 py-2 -mt-6 bg-blue-100 rounded-md shadow-md backdrop-blur-md blur-lg" }
const _hoisted_2 = { class: "px-4 py-2 mt-20 mb-3 bg-purple-100 rounded-md shadow-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "inline-block mb-2 font-semibold text-gray-600 form-label"
}, " New Post ", -1)
const _hoisted_4 = { className: "container mx-auto grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 pt-6 gap-8 -mt-3" }
const _hoisted_5 = { class: "px-2 py-2 bg-purple-100 rounded-md shadow-md" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "inline-block mb-2 font-semibold text-gray-600 form-label"
}, " Markdown Editor ", -1)
const _hoisted_7 = { class: "px-2 py-2 bg-purple-100 rounded-md shadow-md" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "inline-block mb-2 font-semibold text-gray-600 form-label"
}, " HTML Preview ", -1)
const _hoisted_9 = { className: "rounded border-gray-300  dark:border-gray-700 border-dashed border-2 h-48 bg-gray-200 overflow-y-auto" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control block w-full px-3 py-1.5 bg-gray-50 text-base font-normal text-gray-700 bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none",
        id: "exampleFormControlInput1",
        placeholder: "Content...",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
        "data-test": "title"
      }, null, 512), [
        [_vModelText, _ctx.title]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          class: "h-48 mx-2 overflow-y-auto font-serif text-base font-normal text-gray-800 transition duration-300 bg-gray-200 border-2 border-gray-300 border-dashed rounded outline-none cursor-pointer dark:border-gray-700 focus:bg-white",
          contenteditable: "",
          ref: "contentEditable",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
          "data-test": "content"
        }, null, 544)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", { innerHTML: _ctx.html }, null, 8, _hoisted_10)
        ])
      ]),
      _createElementVNode("button", {
        type: "submit",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
        "data-test": "submit",
        class: "text-white bg-yellow-700 w-32 hover:bg-yellow-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      }, " Submit Post ")
    ])
  ]))
}